<template>
<section>

    <div class="find_consultant_img" style=''>
        <img :src="scItem.attUrl">
        <div class="find_consultant_img_gd">
            <!-- <p>평균 ★ {{scItem.reviewAvg}} ({{scItem.reviewScore.reviewCount}}명)</p> -->
        </div>
        
    </div>
    <div>
        <div class="wrap" style="">
            <div class="find_consultant_info" style="position: relative;top: -30px;z-index: 99;">
                
                
                <div class="consultant_info_box">
                    <dl class="consultant_info">
                        <dt>
                            {{scItem.name}} <span>/ 컨설턴트 / 경력 {{$_getScCareer(scItem.scCareers, scItem.joinDt)}}차</span>
                        </dt>
                        <dd>
                            <span>
                                <img :src="scItem.brandAtt ? scItem.brandAtt.url: ''" width="20"> {{ (scItem.shop) ? scItem.shop.name : '' }} 전시장
                            </span>
                            <span>{{ (scItem.dealer) ? scItem.dealer.name : '' }}</span>
                        </dd>
                    </dl>
                    <!--
                    <div class="find_consultant_tag">
                        <div class="communication_box">
                            <div>
                                <span>BMW 5 시리즈</span>
                                <span>BMW 3 시리즈</span>
                            </div>
                            <ul style="justify-content: flex-end;">
                                <li>
                                    <img :src="resource.imgIconGood">
                                    {{ (scItem.reviewScore && scItem.reviewScore.good) ? scItem.reviewScore.good : 0 }}
                                </li>
                                <li>
                                    <img :src="resource.imgIconMessage">
                                    {{ (scItem.reviewScore && scItem.reviewScore.reviewCount) ? scItem.reviewScore.reviewCount : 0 }}
                                </li>
                            </ul>
                        </div>
                    </div>
                    -->
                </div>
                
               
                
                <div class="consultant_introduce">
                    <!--<h4 class="title">소개</h4>-->
                    <div class="contants ">
                        <div class="contants_pbox">
                            <p class="say">
                                {{scItem.content}}
                            </p>
                        </div>
                        <!-- <button class="text_more_btn">소개글 더보기</button> -->
                    </div>
                </div>


                <ReviewData
                    v-if="Object.keys(scItem).length"
                    v-bind="scItem.reviewScore"
                    type-sc>
                </ReviewData>

                <ReviewList 
                    :items="$store.state.review.items" 
                    :totalCount="$store.state.review.totalCount"
                    :to="`/scReview/${scItem.id}`">
                </ReviewList>

            </div>
        </div>
    </div>
    
</section>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import ReviewData from '../../components/review/ReviewData.vue';
import ReviewList from '../../components/review/ReviewList.vue';
import { NumberFormatMixin } from '../../mixins/NumberFormatMixin';

export default {
    name:'ScInfo',
    mixins: [ NumberFormatMixin ],
    components:{
        ReviewData,
        ReviewList,
    },
    data() {
        return {
            scItem: {
                att: null,
                attUrl: '',
                reviewAvg : 0.0,
            },
        }
    },
    computed: {
        ...mapState(["resource"]),
        ...mapState({
            brandItems: state => state.brand.items,
            // scItem: state => state.sc.item,
        }),
        ...mapGetters([
            'viewScAttUrl'
        ]),
        scId() {
            return this.$route.params.scId; 
        }
    },
    created() {
        this.$store.state.headerBlank = false;
        this.getItem();
        this.getReviewList();
    },

    methods: {
        
        async getItem() {
            await this.$store.dispatch('GET_SC', this.scId)
            .then( (data) => { 
                let scItem = data;
                scItem.attUrl = this.viewScAttUrl((scItem.att) ? scItem.att.url : null)
                scItem.reviewAvg = scItem.reviewScore.reviewSum/scItem.reviewScore.reviewCount;
                this.scItem = scItem;
            })


            this.$store.commit('SHOW_ONLOAD');
        },

        getReviewList() {
            this.$store.dispatch('GET_REVIEW_LIST_PAGE', {
                scId: this.scId, 
                hasContent: 1, 
                size: 5
            });
        }

    },
    
}
</script>

<style>
.free_book_data .title {
    display:none
}
</style>